<script lang="ts">
  import { cn } from "$lib/utils/ui";
  import type { Snippet } from "svelte";
  import { Colors } from ".";

  const colors = {
    [Colors.GRAY]: "bg-gray-50 text-gray-600 ring-gray-500/10",
    [Colors.RED]: "bg-red-50 text-red-700 ring-red-600/10",
    [Colors.YELLOW]: "bg-yellow-50 text-yellow-800 ring-yellow-600/20",
    [Colors.GREEN]: "bg-green-50 text-green-700 ring-green-600/20",
    [Colors.BLUE]: "bg-blue-50 text-blue-700 ring-blue-700/10",
    [Colors.INDIGO]: "bg-indigo-50 text-indigo-700 ring-indigo-700/10",
    [Colors.PURPLE]: "bg-purple-50 text-purple-700 ring-purple-700/10",
    [Colors.PINK]: "bg-pink-50 text-pink-700 ring-pink-700/10",
    [Colors.ORANGE]: "bg-orange-50 text-orange-700 ring-orange-700/10",
  };

  interface Props {
    color: Colors;
    children: Snippet;
    shape?: "rounded" | "pill";
    font?: "normal" | "bold" | "mono";
  }

  let { color, children, shape = "pill", font = "normal" }: Props = $props();

</script>

<span class={cn(
    "inline-flex items-center px-2 py-1 text-xs font-medium ring-1 ring-inset",
    colors[color],
    shape === "rounded" ? "rounded-md" : null,
    shape === "pill" ? "rounded-full" : null,
    font === "mono" ? "font-mono" : null,
    font === "bold" ? "font-bold" : null,
)}
  >{@render children()}</span
>
